export default __webpack_public_path__ + "static/media/Animals_29.e14ce56c.png";